import { runInAction } from 'mobx'
import { cinemaGroupDomain } from '../domain/cinemaGroupDomain'
import type { CinemaGroup } from '../models/cinemaGroup.models'

export const setSelectedCinemaGroup = (cinemaGroup: CinemaGroup | null) => {
    runInAction(() => {
        cinemaGroupDomain.data.selected = cinemaGroup
    })
}
